const blogSelectors = {

};

class TemplateBlogArticleJS {
    constructor() {
        
        this._validateCommentForm();
        this._scrollsectionActive();
    }
    
    

    _validateCommentForm=()=>{
        const commentForm = document.querySelector('#comment_form');
        commentForm?.addEventListener('submit',(event)=>{
            let email = commentForm.querySelector('[type="email"]');
            if(!Utility.validateEmail(email.value)){
                event.preventDefault();
                event.stopImmediatePropagation();
                commentForm.querySelector('[data-error="email"]')?.classList.remove('d-none');
            }else{
                commentForm.querySelector('[data-error="email"]')?.classList.add('d-none');
            }

        })
    }

    _scrollsectionActive = () => {
        document.addEventListener('scroll', (event) => {
            let stickybar_wrapper = document.querySelector('[data-state-dropdown-parent]');
            if (stickybar_wrapper) {
                if (!Utility.in_Viewport(document.querySelector('[data-state-chart-heading]'))) {
                    stickybar_wrapper?.classList.add('active')
                }else{
                    stickybar_wrapper?.classList.remove('active')
                }
            }
        })
    }
}

typeof TemplateBlogArticleJS !== 'undefined' && new TemplateBlogArticleJS();
